export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 5", "year 6"],
    category: "heading",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "heading",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          name: "direction",
        },
      ],
    },
  },
);
